// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Component, OnInit, Input, ViewChild, AfterViewInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GeneralDeleteModalComponent } from '@app/access-management/shared/delete-modal/delete-modal.component';
import { RolesService, GoAction, IAM_ROUTE, readParameterFromRouterState } from '@app/core';
import { UserDetailsFacadeService } from '@app/access-management/state/user-details/user-details.facade';
import { DataTableAjaxComponent } from '@app/shared/data-table-ajax/data-table-ajax.component';
import { Store } from '@ngrx/store';
import { RoleScopesSummary } from '@app/access-management/core/services/role-scopes.helpers';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-user-details-roles-tab',
  templateUrl: './user-details-roles-tab.component.html',
  styleUrls: ['./user-details-roles-tab.component.scss']
})
export class UserDetailsRolesTabComponent implements OnInit, AfterViewInit {
  @ViewChild('actionTemplate') actionTemplate: any;
  @ViewChild('scopesTpl') scopesTpl: any;

  @ViewChild('dataTableAjax') dataTableAjax!: DataTableAjaxComponent;
  @Input() roles: any[] | undefined = undefined;
  @Input() username: string | undefined;

  columns: any[] = [];
  role$: any;

  _isUserAdmin = true;

  constructor(
    private store: Store<any>,
    private modalService: NgbModal,
    private rolesService: RolesService,
    private activatedRoute: ActivatedRoute,
    private userDetailsFacade: UserDetailsFacadeService
  ) {
    this.username = readParameterFromRouterState(this.activatedRoute, 'username');
  }

  ngOnInit(): void {}

  trackColumns(id: string) {
    return id;
  }

  scopeFormat(userDetails: any[]): string[] {
    return RoleScopesSummary(userDetails);
  }

  ngAfterViewInit() {
    this.columns = [
      {
        name: 'Name',
        prop: 'role_name',
        cellClass: 'ml-8',
        headerClass: 'ml-8',
        flexGrow: 2
      },
      {
        name: 'Actions',
        cellTemplate: this.actionTemplate,
        sortable: false,
        flexGrow: 1
      }
    ];
  }

  onRemoveRow(row: any) {
    const ModalFixture = this.modalService.open(GeneralDeleteModalComponent, {
      centered: true,
      windowClass: 'no-border'
    });
    const modal: GeneralDeleteModalComponent = ModalFixture.componentInstance;

    modal.observable = this.rolesService.updateRoleDetail(row.role_id, { username: this.username });

    modal.onSuccessRemove = () => {
      this.userDetailsFacade.removeRoleSucceed(row.id);
      this.roles = this.roles && this.roles.filter(role => role.id !== row.id);
      modal.close();
      if (this.dataTableAjax) {
        this.dataTableAjax.refreshTable();
      }
    };

    modal.onFailRemove = () => {
      this.userDetailsFacade.removeRoleFailed();
    };
  }

  onEditClick(row: any) {
    this.store.dispatch(new GoAction(['/', IAM_ROUTE, 'users', this.username, 'roles', row.role_id]));
  }
}



// WEBPACK FOOTER //
// ./src/app/access-management/users/user-details/user-details-roles-tab/user-details-roles-tab.component.ts